import Image from './Image';

export { type ImageProps } from './Image';
export default Image;
